// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"651":"98b33de8","787":"9893900d"}[chunkId] + ".chunk.js";
};